var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productsInCart)?_c('div',{staticClass:"badge e2e-cart-badge"},[_vm._v(" "+_vm._s(_vm.productsInCart)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }